import BankApplication from '@/pages/bank/Application';
import GuaranteeApplication from '@/pages/guarantee/Application';
import User from '@/pages/user';
import MyApplication from '@/pages/myApplication/List';
import MyApplicationDetail from '@/pages/myApplication/Detail';
import Authentication from '@/pages/authentication';
import MajorFinancingApplication from '@/pages/majorFinancing/Application';
import AgrProductProcessingProjects from '@/pages/projectScheduling/agrProductProcessingProjects';
import HundredBillionAgrProject from '@/pages/projectScheduling/hundredBillionAgrProject';
import SupplyChainFinanceHome from '@/pages/supplyChainFinance/home';
import SupplyChainFinanceApplication from '@/pages/supplyChainFinance/application';
import SupplyChainFinancingApplication from '@/pages/supplyChainFinance/financingApplication';
import SupplyChainInsuranceApplication from '@/pages/supplyChainFinance/insuranceApplication';
import SupplyChainFinanceRelationshipConfirm from '@/pages/supplyChainFinance/relationshipConfirm';
import SupplyChainFinanceDeclaration from '@/pages/supplyChainFinance/declaration';
import ProjectSchedulingMyProject from '@/pages/projectScheduling/myProject';
import ProjectSchedulingMyProjectDetail from '@/pages/projectScheduling/myProject/components/Detail';

export const rootRouter = [
  { path: '/bank/application', element: (<BankApplication />), requiresAuth: true },
  { path: '/guarantee/application', element: (<GuaranteeApplication />), requiresAuth: true },
  { path: '/user', element: (<User />) },
  { path: '/myApplication', element: (<MyApplication />), requiresAuth: true },
  { path: '/myApplication/detail', element: (<MyApplicationDetail />), requiresAuth: true },
  { path: '/authentication', element: (<Authentication />) },
  { path: '/majorFinancing/application', element: (<MajorFinancingApplication />) },
  { path: '/projectScheduling/agrProductProcessingProjects', element: (<AgrProductProcessingProjects />), requiresAuth: true },
  { path: '/projectScheduling/hundredBillionAgrProject', element: (<HundredBillionAgrProject />), requiresAuth: true },
  { path: '/supplyChain/home', element: (<SupplyChainFinanceHome />), requiresAuth: true },
  { path: '/supplyChain/application', element: (<SupplyChainFinanceApplication />), requiresAuth: true },
  { path: '/supplyChain/relationshipConfirm', element: (<SupplyChainFinanceRelationshipConfirm />), requiresAuth: true },
  { path: '/supplyChain/declaration', element: (<SupplyChainFinanceDeclaration />), requiresAuth: true },
  { path: '/supplyChain/financingApplication', element: (<SupplyChainFinancingApplication />), requiresAuth: true },
  { path: '/supplyChain/insuranceApplication', element: (<SupplyChainInsuranceApplication />), requiresAuth: true },
  { path: '/projectScheduling/myProject', element: (<ProjectSchedulingMyProject />), requiresAuth: true },
  { path: '/projectScheduling/myProject/detail', element: (<ProjectSchedulingMyProjectDetail />), requiresAuth: true },
];
